import React from "react";
import { Modal, ModalHeader, ModalBody, Button } from "reactstrap";

const SaveHierarchyModal = ({
  isOpenHierarchy,
  toggleHierarchy,
  onSubmit,
  onSubmitHierarchy,
  promptText = "Would you like to save this event across the entire program hierarchy?",
  onlyThisLabel = "No, only save to this program",
  hierarchyLabel = "Yes, save to Hierarchy",
}) => {
  return (
    <>
      <Modal
        className={`modal-event-hierarchy modal-md`}
        isOpen={isOpenHierarchy}
        toggle={toggleHierarchy}
      >
        <ModalHeader>
          <div>{promptText}</div>
        </ModalHeader>
        <ModalBody className="modal-lg" style={{ textAlign: "left" }}>
          <Button
            outline
            className="btn btn-primary btn-sm"
            onClick={onSubmit}
            color="#ffffff"
          >
            {onlyThisLabel}
          </Button>
          <Button
            outline
            className="btn btn-primary btn-sm"
            onClick={onSubmitHierarchy}
            color="#ffffff"
            style={{ float: "left" }}
          >
            {hierarchyLabel}
          </Button>
          <Button
            outline
            color="primary"
            className="btn btn-sm"
            onClick={toggleHierarchy}
            style={{ float: "right" }}
          >
            Cancel
          </Button>
        </ModalBody>
      </Modal>
    </>
  );
};

export default SaveHierarchyModal;
